import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    yate: '',
    fecha: '',
    personas: '',
    mensaje: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validar campos requeridos
    if (!formData.nombre || !formData.email || !formData.telefono) {
      alert('Por favor completa todos los campos obligatorios');
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d4teikatj9hepa8fj2u0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formDataToSend as any).toString()
      });

      if (response.ok) {
        alert('¡Mensaje enviado exitosamente! Nos pondremos en contacto contigo pronto.');
        setFormData({
          nombre: '',
          email: '',
          telefono: '',
          yate: '',
          fecha: '',
          personas: '',
          mensaje: ''
        });
      } else {
        throw new Error('Error al enviar el formulario');
      }
    } catch (error) {
      alert('Error al enviar el mensaje. Por favor intenta nuevamente.');
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-6 font-playfair">
            Contacta con MAR AZUL
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-400 mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            ¿Listo para vivir la aventura náutica perfecta? Contáctanos y reserva tu experiencia de lujo en Los Cabos
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h4 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 via-teal-400 via-emerald-400 to-orange-400 bg-clip-text text-transparent tracking-wide mb-6">
                VIP CABO YACHT RENTALS
              </h4>
              <p className="text-xl text-gray-300 mb-8 font-light">
                Contáctanos para crear tu experiencia náutica perfecta en Los Cabos
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-center p-4 bg-slate-800/30 backdrop-blur-xl rounded-xl border border-cyan-500/20">
                <div className="w-12 h-12 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-xl flex items-center justify-center mr-4">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Dirección</div>
                  <span className="text-gray-300">
                    Blvd. Paseo de la Marina 57-D, Centro, Marina, 23450 Cabo San Lucas, B.C.S., México
                  </span>
                </div>
              </div>

              <div className="flex items-center p-4 bg-slate-800/30 backdrop-blur-xl rounded-xl border border-cyan-500/20">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl flex items-center justify-center mr-4">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Teléfono</div>
                  <span className="text-gray-300">+52 229 157 8562</span>
                </div>
              </div>

              <div className="flex items-center p-4 bg-slate-800/30 backdrop-blur-xl rounded-xl border border-cyan-500/20">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl flex items-center justify-center mr-4">
                  <i className="ri-mail-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Email</div>
                  <span className="text-gray-300">ventas@vipcaboyachtrentals.com</span>
                </div>
              </div>

              <div className="flex items-center p-4 bg-slate-800/30 backdrop-blur-xl rounded-xl border border-cyan-500/20">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center mr-4">
                  <i className="ri-whatsapp-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">WhatsApp</div>
                  <span className="text-gray-300">Reservas inmediatas</span>
                </div>
              </div>
            </div>

            {/* Operating Hours */}
            <div className="bg-slate-800/30 backdrop-blur-xl rounded-xl border border-cyan-500/20 p-6">
              <h5 className="text-xl font-bold text-white mb-4 flex items-center">
                <i className="ri-time-line mr-2 text-cyan-400"></i>
                Horarios de Atención
              </h5>
              <div className="space-y-2 text-gray-300">
                <div className="flex justify-between">
                  <span>Lunes - Viernes:</span>
                  <span>8:00 AM - 8:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Sábados:</span>
                  <span>8:00 AM - 9:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span>Domingos:</span>
                  <span>9:00 AM - 7:00 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-slate-800/30 backdrop-blur-xl rounded-2xl border border-cyan-500/20 p-8">
            <h5 className="text-2xl font-bold text-white mb-6">Solicitar Cotización</h5>
            
            <form onSubmit={handleSubmit} className="space-y-6" data-readdy-form="contacto" id="contacto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="nombre" className="block text-white font-medium mb-2">
                    Nombre completo *
                  </label>
                  <input
                    type="text"
                    id="nombre"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white placeholder-gray-400 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                    placeholder="Tu nombre completo"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-white font-medium mb-2">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white placeholder-gray-400 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                    placeholder="tu@email.com"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="telefono" className="block text-white font-medium mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white placeholder-gray-400 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                    placeholder="+52 000 000 0000"
                  />
                </div>
                
                <div>
                  <label htmlFor="personas" className="block text-white font-medium mb-2">
                    Número de personas
                  </label>
                  <select
                    id="personas"
                    name="personas"
                    value={formData.personas}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                  >
                    <option value="">Seleccionar</option>
                    <option value="1-5">1-5 personas</option>
                    <option value="6-10">6-10 personas</option>
                    <option value="11-15">11-15 personas</option>
                    <option value="16-20">16-20 personas</option>
                    <option value="20+">Más de 20 personas</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="yate" className="block text-white font-medium mb-2">
                    Yate de interés
                  </label>
                  <select
                    id="yate"
                    name="yate"
                    value={formData.yate}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                  >
                    <option value="">Seleccionar yate</option>
                    <option value="ferretti-80ft">Ferretti 80ft</option>
                    <option value="azimut-68ft">Azimut 68ft Papillon</option>
                    <option value="azimut-60ft">Azimut 60ft</option>
                    <option value="patron-88ft">Patron Yacht 88ft</option>
                    <option value="black-watch-38ft">Black Watch 38ft</option>
                    <option value="otro">Otro / No estoy seguro</option>
                  </select>
                </div>
                
                <div>
                  <label htmlFor="fecha" className="block text-white font-medium mb-2">
                    Fecha preferida
                  </label>
                  <input
                    type="date"
                    id="fecha"
                    name="fecha"
                    value={formData.fecha}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-white font-medium mb-2">
                  Mensaje adicional
                </label>
                <textarea
                  id="mensaje"
                  name="mensaje"
                  rows={4}
                  maxLength={500}
                  value={formData.mensaje}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-slate-700/50 border border-cyan-500/30 rounded-lg text-white placeholder-gray-400 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-400/20 transition-all text-sm resize-none"
                  placeholder="Cuéntanos sobre tu experiencia ideal, ocasión especial, o cualquier requerimiento específico... (máximo 500 caracteres)"
                ></textarea>
                <div className="text-right text-xs text-gray-400 mt-1">
                  {formData.mensaje.length}/500 caracteres
                </div>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-4 rounded-xl font-bold hover:from-cyan-400 hover:to-blue-500 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line mr-2"></i>Enviar Solicitud
              </button>
            </form>
          </div>
        </div>

        {/* Map */}
        <div className="mt-16">
          <div className="bg-slate-800/30 backdrop-blur-xl rounded-2xl border border-cyan-500/20 overflow-hidden h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.8234567890123!2d-109.91234567890123!3d22.89012345678901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4b48a123456%3A0x789abcdef0123456!2sBlvd.%20Paseo%20de%20la%20Marina%2057-D%2C%20Centro%2C%20Marina%2C%2023450%20Cabo%20San%20Lucas%2C%20B.C.S.%2C%20M%C3%A9xico!5e0!3m2!1ses!2smx!4v1234567890123!5m2!1ses!2smx"
              width="100%"
              height="100%"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación MAR AZUL - Blvd. Paseo de la Marina 57-D"
              className="w-full h-full"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}